import { render, staticRenderFns } from "./commodsRules.vue?vue&type=template&id=5e66d431&scoped=true"
import script from "./commodsRules.vue?vue&type=script&lang=ts"
export * from "./commodsRules.vue?vue&type=script&lang=ts"
import style0 from "./commodsRules.vue?vue&type=style&index=0&id=5e66d431&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66d431",
  null
  
)

export default component.exports